import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const sumAsync = async (source, selector) => {
    const dataFunc = nextIterationAsync(source, selector);
    const values = await typeDataToArray(dataFunc);
    let sum = 0;
    for (const value of values) {
        sum += value;
    }
    return sum;
};
